import { render, staticRenderFns } from "./FrontView.vue?vue&type=template&id=53354870"
import script from "./FrontView.vue?vue&type=script&lang=js"
export * from "./FrontView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports